export interface FeatureSurveyOption {
  id: string
  label: string
  /** Optional longer explanation shown under an expand control in the popup. */
  description?: string | null
  requires_custom?: boolean
}

export interface FeatureSurveyStatus {
  survey_key: string | null
  submitted: boolean
  is_active: boolean
  eligible?: boolean
  points_spent?: number
  min_points_required?: number
  title: string | null
  description: string | null
  max_selections: number
  options: FeatureSurveyOption[]
}

export const DEFAULT_SURVEY_MIN_POINTS = 15

export function isFeatureSurveyEligible(data: Pick<
  FeatureSurveyStatus,
  'eligible' | 'points_spent' | 'min_points_required'
>): boolean {
  if (typeof data.eligible === 'boolean') return data.eligible
  if (typeof data.points_spent === 'number') {
    return data.points_spent >= (data.min_points_required ?? DEFAULT_SURVEY_MIN_POINTS)
  }
  return false
}

export interface FeatureSurveyConfig {
  survey_key: string
  title: string
  description: string | null
  options: FeatureSurveyOption[]
  max_selections: number
  is_active: boolean
}

export interface FeatureSurveyAdminResponse {
  config: FeatureSurveyConfig
  created_at: string | null
  updated_at: string | null
}

export interface FeatureSurveyListItem {
  survey_key: string
  title: string
  is_active: boolean
  created_at: string | null
  updated_at: string | null
}

export interface FeatureSurveySummaryRow {
  option_id: string
  label: string
  count: number
}

export interface FeatureSurveyAnswerRow {
  id: number
  user_id: number
  user_email: string | null
  user_name: string | null
  selected_options: string[]
  selected_labels: string[]
  custom_answer: string | null
  created_at: string | null
}

export interface FeatureSurveyResults {
  survey: FeatureSurveyConfig | null
  total_responses: number
  summary: FeatureSurveySummaryRow[]
  responses: FeatureSurveyAnswerRow[]
}

export const FEATURE_SURVEY_KEYS = {
  status: ['featureSurveyStatus'] as const,
  adminCurrent: ['adminFeatureSurveyCurrent'] as const,
  adminList: ['adminFeatureSurveyList'] as const,
  adminResponses: (surveyKey?: string) => ['adminFeatureSurveyResponses', surveyKey ?? 'active'] as const,
}

export const DEFAULT_MAX_SELECTIONS = 2

export const EMPTY_SURVEY_OPTION: FeatureSurveyOption = {
  id: '',
  label: '',
  description: '',
  requires_custom: false,
}
